import * as swcHelpers from '@swc/helpers';
import { validateCheckoutRoute } from './validate-checkout-route.js';

const getCheckoutPageInitialProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(ctx) {
        const { query , apolloClient , pathname , res  } = ctx;
        const { cartId , cartHash ='' , type  } = query || {};
        if (cartId) {
            if (!apolloClient) {
                // If no apolloClient could be extracted, render the error page
                console.error(`ApolloClient not present in context for page ${pathname}`);
            } else {
                const validationResult = yield validateCheckoutRoute({
                    apolloClient,
                    cartHash,
                    cartId,
                    pathname,
                    type
                });
                if ((validationResult === null || validationResult === void 0 ? void 0 : validationResult.isCheckoutValid) === false) {
                    res === null || res === void 0 ? void 0 : res.writeHead(307, {
                        Location: validationResult.redirectUrl
                    });
                    res === null || res === void 0 ? void 0 : res.end();
                }
            }
        }
        return {};
    });
    return function getCheckoutPageInitialProps(ctx) {
        return _ref.apply(this, arguments);
    };
}();

export { getCheckoutPageInitialProps };
//# sourceMappingURL=get-checkout-page-initial-props.js.map
